import r from"react";import t from"react-timeago";var e=function(e){var a=e.date,o=e.formatter,i=e.minPeriod;return r.createElement(t,{suppressHydrationWarning:!0,minPeriod:i,date:a,formatter:o})};export{e as default};
